import React from 'react'

import SvgMultiElements from '../SvgMultiElements'
import sellConfig from '../../../assets/icons/sell'

const SellIcon = () => <SvgMultiElements config={sellConfig} />

export default SellIcon
